interface LossProbabilityBadgeProps {
    probability: number;
    riskLevel: string;
    confidence: string;
    size?: 'sm' | 'md' | 'lg';
}

export function LossProbabilityBadge({
    probability,
    riskLevel,
    confidence,
    size = 'md'
}: LossProbabilityBadgeProps) {
    const colors: Record<string, string> = {
        critical: 'bg-red-100 text-red-800 border-red-200',
        high: 'bg-orange-100 text-orange-800 border-orange-200',
        medium: 'bg-yellow-100 text-yellow-800 border-yellow-200',
        low: 'bg-green-100 text-green-800 border-green-200',
    };

    const sizeClasses = {
        sm: {
            container: 'px-2 py-1 rounded-md',
            percentage: 'text-lg font-bold mr-1.5',
            label: 'text-xs',
        },
        md: {
            container: 'px-3 py-1.5 rounded-full',
            percentage: 'text-2xl font-bold mr-2',
            label: 'text-xs',
        },
        lg: {
            container: 'px-4 py-2 rounded-xl',
            percentage: 'text-3xl font-bold mr-3',
            label: 'text-sm',
        },
    };

    const classes = sizeClasses[size];

    return (
        <div className={`inline-flex items-center border ${colors[riskLevel]} ${classes.container}`}>
            <span className={classes.percentage}>{probability}%</span>
            <div className={classes.label}>
                <div className="font-medium capitalize">{riskLevel} Risk</div>
                <div className="opacity-75">{confidence} confidence</div>
            </div>
        </div>
    );
}
